// Keep in sync with node/utils/constants/changelog_constants.js
export const AUDIENCES = ['creators', 'brands', 'managers', 'shoppers', 'admin'];
export const CATEGORIES = ['feature', 'fix', 'improvement', 'deprecated'];
export const PLATFORMS = ['web', 'mobile'];
export const CATEGORY_LABELS = {
  feature: 'Feature',
  fix: 'Fix',
  improvement: 'Improvement',
  deprecated: 'Deprecated',
};
